

export const allProjectFilePaths = [
  // "./projects/example",
  "./projects/DGD-NeRF",
  "./projects/Deep3dComp",
  "./projects/Rollbody",
  "./projects/PWTerm",
  "./projects/Musio",
  "./projects/EthicAI",
  "./projects/PeakFocus",
  "./projects/Catalyst",
  "./projects/Logzilla",
  // ADD MORE PROJECT PATHS HERE
];

export const allProjectDicts = allProjectFilePaths.map((path) => {
  return require(path + "/project.js").contentDict;
})


export const allBlogPostFilePaths = [
  // "./blogPosts/example",
  "./blogPosts/example",
  "./blogPosts/diffusion_models",
  "./blogPosts/3d_metrics",
  // "./blogPosts/nerf_applications",
  // ADD MORE PROJECT PATHS HERE
];


export const allBlogPostDicts = allBlogPostFilePaths.map((path) => {
  return require(path + "/post.js").contentDict;
})



export default allProjectDicts;